module.exports = __webpack_public_path__ + "static/img/santa2.aa4d524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/santa2.png
// module id = xxcj
// module chunks = 1